// Wizard /app/signature: steps maiores 0 Declaracoes, 1 Assinaturas, 2 Download (so se aprovada)

const STEP_DECLARACOES = { id: 0, label: 'Declarações' };
const STEP_ASSINATURAS = { id: 1, label: 'Assinaturas' };
const STEP_DOWNLOAD = { id: 2, label: 'Download' };

// Retorna array de main steps (2 ou 3; Download so quando aprovada)
export function getMainSteps(buttonDownload) {
  const steps = [STEP_DECLARACOES, STEP_ASSINATURAS];
  if (buttonDownload) steps.push(STEP_DOWNLOAD);
  return steps;
}

// Infere main step atual por status (buttonSign/buttonDownload)
export function getInferredMainStep(context) {
  if (context.isRespJur) return 1;
  if (context.buttonDownload) return 2;
  if (context.buttonSign) return 1;
  return 0;
}

// Usa etapa salva se valida; so infere quando nao ha etapa salva valida
export function resolveActiveMainStep(savedStep, context) {
  const maxStep = context.buttonDownload ? 2 : 1;
  if (typeof savedStep === 'number' && savedStep >= 0 && savedStep <= maxStep) {
    return savedStep;
  }
  return getInferredMainStep(context);
}

// Declaracao preenchida = valor truthy (true, 1, 'Sim', etc.)
export function isDeclarationCompleted(client) {
  const v = client?.completedhealthdeclaration ?? client?.dataValues?.completedhealthdeclaration;
  return Boolean(v);
}

export function isMainStepCompleted(mainStepIndex, context) {
  if (mainStepIndex === 0) {
    if (context.isRespJur) return true;
    if (context.tipooperacao === 'Cartão' || context.tipooperacao === 'Odonto') return true;
    const clients = context.infosClients || [];
    return clients.length === 0 || clients.every((c) => isDeclarationCompleted(c));
  }
  if (mainStepIndex === 1) return context.buttonSign === false;
  return mainStepIndex === 2;
}

// Permite avançar para proximo main step? (validacao + mensagem)
export function canAdvanceMainStep(activeMainStep, context) {
  const mainSteps = getMainSteps(context.buttonDownload);
  if (activeMainStep >= mainSteps.length - 1) return { allowed: false };
  if (activeMainStep === 0 && !isMainStepCompleted(0, context)) {
    return {
      allowed: false,
      message: 'Conclua as declarações de saúde dos beneficiários antes de avançar.'
    };
  }
  return { allowed: true };
}
